//记得在 src\components\lang\zhLoad.js 里面添加对象
const market = {
  marketName:'市场',
  travelAgencyName: '地接社',
  msg: {}
};
export default market



// WEBPACK FOOTER //
// ./src/page/md/market/lang/market.zh.js